function jsShapesOverlay() {
	if ($(".js-shapes-overlay").length) {
		$("body").addClass('overlay');
		$(".js-shapes-overlay").each(function() {
			// depth range: 4 / 10
			if ($(this).attr("data-depth")) {
				var depth = $(this).attr("data-depth");
			} else {
				var depth = 4;
			}
			var position = $(window).scrollTop();
			var positionTransform = "translateY(" + position / depth + "px)";
			$(this).css({
				transform: positionTransform
			});
		});
	}
}


function navAccordion() {
	if ($(window).width() < 980) {
		$(".nav__item--heading").siblings().slideUp();

		$(".nav__item--heading").click(function() {
			$(this).siblings().slideToggle();
			$(this).toggleClass("nav__item--heading--active");
			return false;
		});
	}
}

function imageSlider() {
	if ($(".js-image-slider").length) {
		if ($(window).width() < 700) {
			$(".js-image-slider").slick({
				autoplay: true,
				autoplaySpeed: 3000,
				dots: true
			});
		}
	}
}

function navScroll() {
	var headerPosition = $(".js-header").offset().top;
	var mainPosition = $("#main").offset().top + 100;

	if (headerPosition >= mainPosition) {
		$(".js-header").addClass("header--scroll");
	} else {
		$(".js-header").removeClass("header--scroll");
	}
}


function fixedHeroScroll() {
	if ($(".js-fixed-scroll-hero").length) {
		var box = $('.js-fixed-scroll-hero');
		var boxTop = box.offset().top;
		var boxBottom = boxTop + box.outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		// Check if the box is in the viewport
		if (boxBottom > viewportTop && boxTop < viewportBottom) {
			box.toggleClass('active', true); // Add class if in viewport
		} else {
			box.toggleClass('active', false); // Remove class if not in viewport
		}
	}
}

$(".js-fade-in-row").addClass("js-fade-in-row--hidden");
function scrollRowAnimation() {
	if ($(".js-fade-in-row").length) {
		if ($(window).width() > 1000) {
			$(".js-fade-in-row").each(function() {
				var divPos = $(this).offset().top;
				var topOfWindow = $(window).scrollTop();
				var height = $(window).height();

				if (divPos < topOfWindow + height - 200) {
					$(this).children().each(function(index) {
						var $this = $(this);
						setTimeout(function() {
							$this.addClass("js-fade-in-row--visible");
						}, 300 * index);
					});
				}
			});
		}
	}
}

$(document).ready(function() {
	navScroll();
	imageSlider();
	scrollRowAnimation();
	navAccordion();
	fixedHeroScroll();
	

	$(".js-nav-trigger").click(function() {
		$(this).toggleClass("nav-button--active");

		if ($(window).width() < 980) {
			$(".header").toggleClass("header--split-reverse");
		} else {
			$(".header").toggleClass("header--dark");
		}
		$(".navigation").toggleClass("navigation--active");
	});

	$(".js-testimonials-slider").slick({
		autoplay: true,
		autoplaySpeed: 8500,
		dots: true
	});
});

$(window).scroll(function() {
	navScroll();
	scrollRowAnimation();
	jsShapesOverlay();
	fixedHeroScroll();
});

$(window).resize(function() {
	imageSlider();
});
